import { Col, DatePicker, Form, Input, Row } from 'antd'
import CustomSpin from '../../../../elements/CustomSpin'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import withSort from '../../../../elements/HOC/withSort'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import withData from '../../../../elements/Select/withData'
import { get } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import { dateVal, normalizeNull } from '../../../../modules/Utils'
import React, { useState } from 'react'

import { compose } from 'recompose'

const { RangePicker } = DatePicker
const { TextArea } = Input

function StatementForm(props) {
  const { statement, fetching, isNew } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  const company = getFieldValue('company._id')
  const [BankSelectCmp] = useFetchSelectUrl(
    {
      name: 'banks',
      url: `corporates/banks/?status=Active&owner=${company}`,
    },
    [company],
  )

  const [bank, setBank] = useState({})
  const multiCurrency = get(bank, 'bank.multiCurrency', [])
  const currency = get(bank, 'bank.currency', '')

  const isCreditCard = getFieldValue('type') === 'card'

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        <FormSectionTitle title={'Statement Details'} />
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Type">
              {getFieldDecorator('type', {
                initialValue: get(statement, 'type'),
                rules: rules.select,
              })(<Type />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Company">
              {getFieldDecorator('company._id', {
                initialValue: get(statement, 'company._id'),
                rules: rules.select,
              })(<OrganisationsSelect disabled={!isNew} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Bank Account">
              {getFieldDecorator('bank._id', {
                initialValue: get(statement, 'bank._id'),
                rules: rules.select,
              })(<BankSelectCmp keyAtr={'_id'} valueAtr={'title'} setSelected={setBank} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Statement Number">
              {getFieldDecorator('no', {
                initialValue: get(statement, 'no'),
                rules: rules.input,
              })(<Input placeholder={'Statement Number'} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Statement Date'}>
              {getFieldDecorator('date', {
                initialValue: dateVal(statement, 'date'),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>

          {isCreditCard && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Due Date'}>
                {getFieldDecorator('due', {
                  initialValue: dateVal(statement, 'due'),
                  rules: rules.date,
                })(<DatePicker style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          )}

          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label={'Statement Period'}>
              {getFieldDecorator('period', {
                initialValue: [
                  dateVal(statement, 'period.start'),
                  dateVal(statement, 'period.end'),
                ],
                rules: rules.date,
              })(<RangePicker style={{ width: '100%' }} format="ddd YYYY-MM-DD" />)}
            </Form.Item>
          </Col>

          {multiCurrency.length > 0 && <h3>Main Account Currency</h3>}

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Opening Balance'}>
              {getFieldDecorator('balance.opening', {
                initialValue: get(statement, 'balance.opening'),
                rules: rules.input,
              })(
                <Input
                  type="number"
                  addonBefore={currency}
                  style={{ width: '100%' }}
                  placeholder={'Opening Balance'}
                />,
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Closing Balance'}>
              {getFieldDecorator('balance.closing', {
                initialValue: get(statement, 'balance.closing'),
                rules: rules.input,
              })(
                <Input
                  type={'number'}
                  addonBefore={currency}
                  placeholder={'Closing Balance'}
                  style={{ width: '100%' }}
                />,
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Total Credit Amount'}>
              {getFieldDecorator('amount.credit', {
                normalize: normalizeNull,
                initialValue: get(statement, 'amount.credit'),
              })(
                <Input
                  type={'number'}
                  addonBefore={currency}
                  placeholder={'Total Credit Amount'}
                  style={{ width: '100%' }}
                />,
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Total Debit Amount'}>
              {getFieldDecorator('amount.debit', {
                normalize: normalizeNull,
                initialValue: get(statement, 'amount.debit'),
              })(
                <Input
                  type={'number'}
                  addonBefore={currency}
                  placeholder={'Total Debit Amount'}
                  style={{ width: '100%' }}
                />,
              )}
            </Form.Item>
          </Col>
        </Row>

        {multiCurrency.length > 0 && <h3>Virtual Account Currencies</h3>}
        {multiCurrency.map((c, i) => (
          <Row>
            <h4 style={{ color: '#479365', fontWeight: 'bold', paddingLeft: 20 }}>{c}</h4>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Opening Balance'}>
                {getFieldDecorator(`multiCurrency.${i}.${c}.balance.opening`, {
                  initialValue: get(statement, `multiCurrency.${i}.${c}.balance.opening`),
                  normalize: normalizeNull,
                })(
                  <Input
                    type="number"
                    addonBefore={c}
                    style={{ width: '100%' }}
                    placeholder={'Opening Balance'}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Closing Balance'}>
                {getFieldDecorator(`multiCurrency.${i}.${c}.balance.closing`, {
                  initialValue: get(statement, `multiCurrency.${i}.${c}.balance.closing`),
                  normalize: normalizeNull,
                })(
                  <Input
                    type={'number'}
                    addonBefore={c}
                    placeholder={'Closing Balance'}
                    style={{ width: '100%' }}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Total Credit Amount'}>
                {getFieldDecorator(`multiCurrency.${i}.${c}.amount.credit`, {
                  normalize: normalizeNull,
                  initialValue: get(statement, `multiCurrency.${i}.${c}.amount.credit`),
                })(
                  <Input
                    type={'number'}
                    addonBefore={c}
                    placeholder={'Total Credit Amount'}
                    style={{ width: '100%' }}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Total Debit Amount'}>
                {getFieldDecorator(`multiCurrency.${i}.${c}.amount.debit`, {
                  normalize: normalizeNull,
                  initialValue: get(statement, `multiCurrency.${i}.${c}.amount.debit`),
                })(
                  <Input
                    type={'number'}
                    addonBefore={c}
                    placeholder={'Total Debit Amount'}
                    style={{ width: '100%' }}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
        ))}
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label={'Notes'}>
              {getFieldDecorator('notes', {
                normalize: normalizeNull,
                initialValue: get(statement, 'notes'),
              })(<TextArea placeholder={'Notes'} />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CustomSpin>
  )
}

const Type = compose(
  withData({
    data: [
      { key: 'bank', value: 'Account' },
      { key: 'lender', value: 'Loan' },
      { key: 'card', value: 'Credit Card' },
    ],
  }),
  withSort,
)(CustomSelect)

export default Form.create()((StatementForm))
